export default __webpack_public_path__ + "static/Fellix-ThinItalic-b2e8028dfee21130540c773fa1e99be6.otf";